.gray{color:gray!important}
/*# sourceMappingURL=dynamic-tariffs.page-72OQGWVT.css.map */
